import { createContext, useContext } from "react";

const ReadOnlyContext = createContext<boolean | undefined>(undefined);

export function useReadOnly(): boolean {
  const readOnly = useContext(ReadOnlyContext);
  if (readOnly === undefined) {
    throw new Error("useReadOnly must be used within ReadOnlyProvider");
  }
  return readOnly;
}

interface ReadOnlyProviderProperties {
  children: React.ReactNode;
  value: boolean;
}

export function ReadOnlyProvider({ children, value }: ReadOnlyProviderProperties) {
  return <ReadOnlyContext.Provider value={value}>{children}</ReadOnlyContext.Provider>;
}
